import { render, staticRenderFns } from "./UserFiguresGeneral.vue?vue&type=template&id=75a097a1"
import script from "./UserFiguresGeneral.vue?vue&type=script&lang=js"
export * from "./UserFiguresGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports